import { Card, CardBody, Divider, Box, Text, Flex } from '@chakra-ui/react'
import { AnalysisMalariaReport } from '../../models/analysis-malaria-report'
import Header from './components/Header'
import ReportStatusMsg from './components/ReportStatusMsg'
import ReportStats from './components/ReportStats'
import ReportTable from './components/ReportTable'
import { useTranslation } from 'react-i18next'

export default function AnalysisMalariaResultsCard({
  analysisMalariaReport,
}: {
  analysisMalariaReport: AnalysisMalariaReport
}) {
  const { t } = useTranslation()

  return (
    <Card
      fontFamily={'Poppins'}
      w={'100%'}
      mt={6}
      px={4}
      py={2}
      maxW="100%"
      borderRadius={'lg'}
    >
      <Header updatedAt={analysisMalariaReport.updatedAt} />

      <CardBody pt={0}>
        <Box
          mb={4}
          p={3}
          bg="orange.50"
          borderWidth="1px"
          borderColor="orange.200"
          borderRadius="md"
        >
          <Flex align="center" gap={2}>
            <Text fontSize="lg">⚠️</Text>
            <Text fontSize="sm" color="orange.800" fontWeight="500">
              {t('ai.disclaimer')}
            </Text>
          </Flex>
        </Box>
        <ReportStatusMsg reportProcess={analysisMalariaReport.process} />
        {analysisMalariaReport.hasResults && (
          <ReportStats analysisMalariaReport={analysisMalariaReport} />
        )}
        <Divider my={4} />

        <ReportTable analysisMalariaReport={analysisMalariaReport} />
      </CardBody>
    </Card>
  )
}
